export default __webpack_public_path__ + "static/2010-79c22e068491e2ac13aaaa201bfdfd92.svg";